export function getMouseY(e: TouchEvent | React.TouchEvent<HTMLDivElement>) {
	return e.touches?.[0]?.clientY || e.changedTouches?.[0]?.clientY
}
